module.exports = __webpack_public_path__ + "img/icon_repeat.4aeb3076.svg";